export default "__VITE_ASSET___xMoRtPY__"